var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt-3"},[_c('div',{staticClass:"equip-accordion"},_vm._l((_vm.filtered(_vm.allEquipmentGroups)),function(group){return _c('extra-equipment-group',{key:'extra_' + group.name,attrs:{"group":group}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }